module.exports = __webpack_public_path__ + "img/information-dissemination.517056a5.png";